import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { UserDropdownComponent } from '../../../../shared/components/header/user-dropdown/user-dropdown.component';
import { ThemeToggleButtonComponent } from '../../../../shared/components/theme-toggle/theme-toggle-button.component';

@Component({
  selector: 'app-header',
  imports: [CommonModule, ThemeToggleButtonComponent, UserDropdownComponent],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent {}
